import request from "../../utils/request";
import {
    UserGrossPayView,
    UserGrossPayInput,
    CompanyGrossPayView,
    CompanyGrossPayInput
} from "../../models/payroll";
import { Bank, Result, User } from "../../models/general";


export async function GetUserGrossPaysPerMonth(userId: string, date: string, currencyId: number) {
    const response = await request.get<Result<UserGrossPayView[]>>("GrossPay/GetUserGrossPaysPerMonth", {
        params: { userId, date, currencyId },
    });
    return response.data;
}

export async function AddUserGrossPay(input: UserGrossPayInput) {
    const response = await request.post<Result<UserGrossPayView>>("GrossPay/AddUserGrossPay", input);
    return response.data;
}

export async function UpdateUserGrossPay(input:UserGrossPayInput) {
    const response=await request.post<Result<UserGrossPayView>>(`GrossPay/UpdateUserGrossPay`, input);
    return response.data;
}

export async function GetCompanyGrossPays() {
    const response = await request.get<Result<CompanyGrossPayView[]>>(`GrossPay/GetCompanyGrossPays`);
    return response.data;
}

export async function EditCompanyGrossPay(input : CompanyGrossPayInput) {
    const response = await request.post<Result<CompanyGrossPayView>>(`GrossPay/EditCompanyGrossPay`, input);
    return response.data;
}

/**
 * CO-163: the payload is the ARCHIVED component plus the delete's outcome
 * (`clearedLastBasicSalaryComponent`, `basicSalaryComponentCount`), not a bare `true`. Deleting the
 * flagged component reaches the same zero-statutory-basic-wage state as unticking it, and the caller
 * has to be able to announce that from the server's own answer rather than guessing from stale
 * pre-delete state.
 */
export async function DeleteCompanyGrossPay(id: number) {
    const response = await request.post<Result<CompanyGrossPayView>>(`GrossPay/DeleteCompanyGrossPay/${id}`);
    return response.data;
}

export async function AddCompanyGrossPay(input: CompanyGrossPayInput) {
    const response = await request.post<Result<CompanyGrossPayView>>("GrossPay/AddCompanyGrossPay", input);
    return response.data;
}
